<p-toolbar>
  <div class="-toolbar-group-start">
    <app-header-text-icon />
  </div>

  <div class="p-toolbar-group-end">
    @if (isAuthenticated()) {
      @if (items$ | async; as items) {
        <p-menubar [model]="items"> </p-menubar>
      }
    }

    <app-header-menu-logged />
  </div>
</p-toolbar>
